import React from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons

// core components
import GridItem from "../../../components/Grid/GridItem.js";
import GridContainer from "../../../components/Grid/GridContainer.js";
import Card from "../../../components/Card/Card.js";
import CardHeader from "../../../components/Card/CardHeader.js";
import CardIcon from "../../../components/Card/CardIcon.js";
import Loading from "../../../components/isLoading.js";
import Skeleton from "@material-ui/lab/Skeleton";
import styles from "../../../assets/styles/views/dashboardStyle.js";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(styles);

export default ({ records, isUpdating, role, isCurrentUser }) => {
  const classes = useStyles();

  return records.loading ? (
    <GridContainer justify="center">
      <Loading />
    </GridContainer>
  ) : (
    <GridContainer>
      {records.map((recordElt) => (
        <GridItem xs={12} sm={6} md={3} key={recordElt.title}>
          <Card>
            <CardHeader icon>
              <CardIcon
                color="info"
                style={{ backgroundColor: recordElt.color }}
              >
                <Icon>{recordElt.icon}</Icon>
              </CardIcon>
              <div className={classes.cardCategory}>
                <Typography variant="body1">{recordElt.title}</Typography>
              </div>
              <br></br>
              <h3 className={classes.cardTitle} style={{ textAlign: "right" }}>
                {isUpdating ? (
                  <Skeleton variant="rect" className={classes.skeleton} />
                ) : (
                  `${recordElt.count || 0}`
                )}
              </h3>
            </CardHeader>
          </Card>
        </GridItem>
      ))}
    </GridContainer>
  );
};
